import { merge } from 'lodash';
import view from './view.json';
import { replace } from './replace';

export const french = merge(view, replace);
